import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as verifyEmailActions from '../actions/verify-email.actions';
import { NetworkCallService } from '../../../core/services/network-call.service';
import { Router } from '@angular/router';
import { mergeMap, catchError, concatMap } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';
import notify from 'devextreme/ui/notify';
import { IVerifyEmailRequest, IVerifyEmailResponse } from '../models/verify-email.model';
import { SharedService } from '../../../shared/shared.service';

@Injectable()
export class VerifyEmailEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private sharedService: SharedService,
    private helperService: HelpersService
  ) {}

  verifyEmailAddress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(verifyEmailActions.verifyEmailRequest),
      concatMap(action =>
        this.networkCallService
          .put<IVerifyEmailRequest, IVerifyEmailResponse>('Customer/emailAddressConfirmFromToken', action.request)
          .pipe(
            mergeMap((response: IVerifyEmailResponse) => {
              if(response && response.success){
                this.sharedService.forgotPasscodeResendOTPAfter = response.secondsUntilNextOtpSendAllowed;
                if(response.otpExpired){
                  notify(
                    {
                        message: `Sorry! OTP entered is already expired.`,
                        width: 250,
                        shading: true
                    },
                    'info',
                    2000
                  );
                }else{
                  notify(
                    {
                        message: `Congratulations! Your email verified successfully.`,
                        width: 250,
                        shading: true
                    },
                    'success',
                    2000
                  );
                }
              }else{
                notify(
                  {
                      message: `Email verificatfion failed :(`,
                      width: 250,
                      shading: true
                  },
                  'error',
                  2000
                );
              }
              return concat(of(verifyEmailActions.verifyEmailRequestSuccess({ response })));
            }),
            catchError(error => {
              if(error && error.error && error?.error?.Message || error?.error?.message){
              }else{
                notify(
                  {
                      message: `Email verificatfion failed :(`,
                      width: 250,
                      shading: true
                  },
                  'error',
                  2000
                );
              }
              return of(verifyEmailActions.verifyEmailRequestFailure(error));
            })
          )
      )
    )
  );
}
